var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accounts icon",
    clipPath: "url(#clip0_10542_52641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 5H1.5C1.23478 5 0.98043 5.10536 0.792893 5.29289C0.605357 5.48043 0.5 5.73478 0.5 6V14C0.5 14.2652 0.605357 14.5196 0.792893 14.7071C0.98043 14.8946 1.23478 15 1.5 15H14.5C14.7652 15 15.0196 14.8946 15.2071 14.7071C15.3946 14.5196 15.5 14.2652 15.5 14V6C15.5 5.73478 15.3946 5.48043 15.2071 5.29289C15.0196 5.10536 14.7652 5 14.5 5Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.02764 10.4581C8.39964 10.4581 8.75641 10.3103 9.01946 10.0473C9.2825 9.78424 9.43028 9.42748 9.43028 9.05547C9.43028 8.68347 9.2825 8.3267 9.01946 8.06366C8.75641 7.80061 8.39964 7.65283 8.02764 7.65283C7.65564 7.65283 7.29887 7.80061 7.03582 8.06366C6.77278 8.3267 6.625 8.68347 6.625 9.05547C6.625 9.42748 6.77278 9.78424 7.03582 10.0473C7.29887 10.3103 7.65564 10.4581 8.02764 10.4581Z",
    stroke: "currentColor",
    strokeWidth: 0.549732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.3776 12.6377C10.0703 11.6317 9.11875 10.8774 8.02698 10.8774C6.93412 10.8774 5.98308 11.6317 5.67578 12.6377",
    stroke: "currentColor",
    strokeWidth: 0.549732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.5 3H14.5",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.5 1H12.5",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10542_52641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIcon);
export default __webpack_public_path__ + "static/media/accounts-icon.c6a1b8b0.svg";
export { ForwardRef as ReactComponent };